<template>
    <!-- :disabled="readonly || config.readonly" -->
    <!-- <el-date-picker class="X-Date" v-model="config.date" type="date"  :placeholder="config.placeholder" :size="config.size" /> -->
    <el-date-picker class="x-date"
            :type="getType(config.type)"
            :modelValue="modelValue"
            @update:modelValue="(value, oldvalue)=>$emit('update:modelValue', value, oldvalue)"  
            :disabled="readonly || config.readonly" :format="getFormat(config.format, config.type)"
            :value-format="config.format"></el-date-picker>
</template>
<script setup>
import { defineProps } from 'vue';
import FieldType from '../../datamodule/FieldType';

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    modelValue: { default: null },
    data: { default: null },
    field: { default: null },
})
defineEmits({
  "update:modelValue": null,
});

const getType = (type)=> {
    switch (type) {
        default:
        case FieldType.DATE: return 'date';
        case FieldType.DATETIME: return 'datetime';
    }
}

const getFormat = (format, type)=> {
    if (format) return format;
    switch (type) {
        default:
        case FieldType.DATE: return 'YYYY-MM-DD';
        case FieldType.DATETIME: return 'YYYY-MM-DD HH:mm:ss';
    }
}
</script>
<style>
.x-date {
    width: 100% !important;
}
</style>